(() => {
  const state = window.MMCinematicVideoPlayback || {
    videos: new Set(),
    initialized: false,
    observer: null,
  };
  window.MMCinematicVideoPlayback = state;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const canPlayVideo = (video) => {
    return !motionQuery.matches
      && document.visibilityState !== 'hidden'
      && video.dataset.mmVideoVisible !== 'false';
  };

  const attemptPlay = (video) => {
    if (!canPlayVideo(video)) {
      video.pause();
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    if (video.readyState === 0 && video.dataset.mmLoadRequested !== 'true') {
      video.dataset.mmLoadRequested = 'true';
      video.load();
    }

    const playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(() => {
        video.dataset.mmAutoplayBlocked = 'true';
      });
    }
  };

  const refreshPlayback = () => {
    state.videos.forEach((video) => attemptPlay(video));
  };

  const newVideos = document.querySelectorAll(
    'video[data-mm-cinematic-video]:not([data-mm-video-enhanced])'
  );

  newVideos.forEach((video) => {
    video.dataset.mmVideoEnhanced = 'true';
    video.dataset.mmVideoVisible = 'true';
    state.videos.add(video);

    video.addEventListener('canplay', () => attemptPlay(video));
    video.addEventListener('loadedmetadata', () => attemptPlay(video));
  });

  if (!state.initialized) {
    state.initialized = true;

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.dataset.mmVideoVisible = entry.isIntersecting ? 'true' : 'false';
            attemptPlay(entry.target);
          });
        },
        { threshold: 0.05 }
      );
    }

    document.addEventListener('visibilitychange', refreshPlayback);
    document.addEventListener('pageshow', refreshPlayback);
    document.addEventListener('pointerdown', refreshPlayback, { passive: true });

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', refreshPlayback);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(refreshPlayback);
    }
  }

  newVideos.forEach((video) => {
    if (state.observer) state.observer.observe(video);
    attemptPlay(video);
  });
})();
